// extracted by mini-css-extract-plugin
export var wysiwyg = "Wysiwyg-module--wysiwyg--FkF4M";